import { Gap } from '@salecycle/ui-component-library';
import { FC } from 'react';
import { TimeTopBar } from './filters/TimeTopBar';
import { FilterTopBar } from './filters/FilterTopBar';

export const ReportableDashboardFilters: FC = () => {
  return (
    <>
      <Gap top={10} />
      <FilterTopBar />
      <Gap top={10} />
      <TimeTopBar />
    </>
  );
};
